<template>
  <a-drawer
    :title="textMap[dialogStatus]"
    :visible.sync="visible"
    width="60%"
    :maskClosable="false"
    @cancel="onClose"
    @close="onClose"
  >
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.等级名称')" prop="levelName">
            <a-input v-model="form.levelName" :maxLength="50" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.等级名称')" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.等级名称(英文)')" prop="levelNameEn">
            <a-input v-model="form.levelNameEn" :maxLength="50" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.等级名称(英文)')" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.等级名称(繁体)')" prop="levelNameTc">
            <a-input v-model="form.levelNameTc" :maxLength="50" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.等级名称(繁体)')" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.等级级别')" prop="level">
            <a-input-number v-model="form.level" :min="1" :max="999" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.等级级别')" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.服务费')" prop="serviceFee">
            <a-input-number v-model="form.serviceFee" :min="0" :precision="2" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.服务费')" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.平台抽成比例')" prop="platformRate">
            <a-input-number v-model="form.platformRate" :min="0" :max="100" :precision="2" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.平台抽成比例')" style="width: 100%" />
            <span style="color: #999; margin-left: 8px;">%</span>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('店铺等级.可发布最大商品数量')" prop="maxGoodsCount">
            <a-input-number v-model="form.maxGoodsCount" :min="0" :placeholder="$t('通用.输入.请输入')+$t('店铺等级.可发布最大商品数量')" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('通用.文本.排序')" prop="sort">
            <a-input-number v-model="form.sort" :min="0" :max="999999" :placeholder="$t('通用.输入.请输入')+$t('通用.文本.排序')" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('通用.文本.备注')" prop="remark">
            <a-textarea v-model="form.remark" :rows="4" :maxLength="500" :placeholder="$t('通用.输入.请输入')+$t('通用.文本.备注')" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">{{$t('通用.按钮.保存')}}</a-button>
        <a-button @click="onClose">{{$t('通用.按钮.取消')}}</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getShopLevel, addShopLevel, updateShopLevel } from '@/api/shop/shopLevel'

export default {
  name: 'CreateForm',
  data () {
    return {
      formType: 1,
      submitLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      dialogStatus: 'create',
      textMap: {
        update: this.$t('通用.按钮.修改'),
        create: this.$t('通用.按钮.新增')
      },
      visible: false,
      form: {
        id: null,
        levelName: null,
        levelNameEn: null,
        levelNameTc: null,
        level: 1,
        serviceFee: 0,
        platformRate: 0,
        maxGoodsCount: 0,
        sort: 0,
        remark: null
      },
      rules: {
        levelName: [
          { required: true, message: this.$t('店铺等级.等级名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        level: [
          { required: true, message: this.$t('店铺等级.等级级别') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /** 新增 */
    handleAdd () {
      this.dialogStatus = 'create'
      this.formType = 1
      this.resetForm()
      this.visible = true
    },
    /** 修改 */
    handleUpdate (record) {
      this.dialogStatus = 'update'
      this.formType = 2
      this.resetForm()
      this.visible = true
      this.getDetail(record.id)
    },
    /** 获取详情 */
    getDetail (id) {
      getShopLevel({ id: id }).then(response => {
        this.form = response.data
      })
    },
    /** 提交 */
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateShopLevel(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.修改成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addShopLevel(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.新增成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        }
      })
    },
    /** 关闭 */
    onClose () {
      this.visible = false
    },
    /** 重置表单 */
    resetForm () {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        id: null,
        levelName: null,
        levelNameEn: null,
        levelNameTc: null,
        level: 1,
        serviceFee: 0,
        platformRate: 0,
        maxGoodsCount: 0,
        sort: 0,
        remark: null
      }
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-top: 1px solid #e8e8e8;
}
</style>
